<template>
    <!--
        Barra laterale scritta a mano, al posto dei componenti `CSidebar*` di `@coreui/vue`.
        Le classi sono quelle di CoreUI 3, che il foglio di stile in progetto fornisce gia: la resa
        visiva resta quella di prima, ed e il motivo per cui non si e saliti a CoreUI 5 (che avrebbe
        trascinato Bootstrap 5 e la rinomina di 180 utility in 67 file).
    -->
    <div
        class="c-sidebar c-sidebar-dark c-sidebar-fixed"
        :class="{ 'c-sidebar-lg-show': show, 'c-sidebar-minimized': minimize }"
    >
        <RouterLink to="/" class="c-sidebar-brand d-md-down-none">
            <SVGLogoPulinetSmall v-if="minimize" />
            <SVGLogoPulinetFull v-else />
        </RouterLink>

        <ul class="c-sidebar-nav">
            <template v-if="loggedIn">
                <li
                    v-for="(menuItem, index) in filteredMenuItems"
                    :key="`${menuItem.label}-${index}`"
                    class="c-sidebar-nav-item"
                >
                    <RouterLink :to="{ name: menuItem.name }" active-class="c-active" class="c-sidebar-nav-link">
                        <font-awesome-icon :icon="menuItem.faIcon" class="c-sidebar-nav-icon" />
                        <span>{{ menuItem.label }}</span>
                    </RouterLink>
                </li>
            </template>
            <template v-else>
                <li class="c-sidebar-nav-item">
                    <RouterLink :to="{ name: 'page-login' }" class="c-sidebar-nav-link">
                        <font-awesome-icon icon="sign-in-alt" class="c-sidebar-nav-icon" />
                        <span>{{ $t('login') }}</span>
                    </RouterLink>
                </li>
                <li v-if="showTickets" class="c-sidebar-nav-item">
                    <RouterLink
                        :to="{ name: 'page-manager-tickets-list' }"
                        class="c-sidebar-nav-link"
                        active-class="c-active"
                    >
                        <font-awesome-icon icon="comments" class="c-sidebar-nav-icon" />
                        <span>{{ $t('ticket') }}</span>
                    </RouterLink>
                </li>
            </template>
        </ul>

        <button
            type="button"
            class="c-sidebar-minimizer c-class-toggler d-md-down-none"
            @click="$store.commit('set', ['sidebarMinimize', !minimize])"
        />
    </div>
</template>

<script lang="ts" src="./TheSidebar.ts"></script>
